export enum RedirectToAction {
  NONE = 0,
  ORIGINATION = 1
}

